import "../../styles/components/adm/loader.styles.css"

export const LoaginScreen = () => {
    return (
        <div className="loading-screen">
            <div className="loader"></div>
        </div>
    )
}